export const appEvents = {
  "data": [
    {
      "id": '1',
      "attributes": {
        "Title": "Children's Day Special",
        "Description": '',
        "Date": "2024-05-27",
        "Time": "12:00:00",
        "Address": "ABC Foundation, Ibadan",
        "Content": "TOGCF is delighted to announce a special Children's Day celebration at the ABC Foundation, Ibadan. Our goal is to create a memorable day filled with joy, fun, and smiles for the children.\n\nJoin us for a heartwarming and exciting event that includes:\n\n**Sip and Paint**: Let your creativity flow in a guided painting session.\n\n**Delicious Food and Drinks**: There will be a variety of tasty treats and refreshing drinks.\n\n**Fun-Filled Games:** Engage in a range of entertaining games perfect for all ages.\nIf you happen to have an hour or two to spare, Come and join us for a day of pure joy, dedicated to bringing happiness and unforgettable moments to the children. \n\nIt's going to be more fun than a barrel of monkeys! We can't wait to celebrate with you (and maybe steal a cupcake or two)!\n\nFor more details, sponsorship, or contributions please send an email to: hello@togcf.org or call +2348136327351",
        "createdAt": "2024-05-21T17:54:19.569Z",
        "updatedAt": "2024-05-23T21:47:40.177Z",
        "publishedAt": "2024-05-21T17:54:33.150Z",
        "Image": {
          "data": {
            "id": 2,
            "attributes": {
              "name": "sip 1.jpg",
              "alternativeText": null,
              "caption": null,
              "width": 6583,
              "height": 6583,
              "formats": {
                "large": {
                  "ext": ".jpg",
                  "url": "https://res.cloudinary.com/ddn6ef2kw/image/upload/v1716313856/large_sip_1_eb35b28131.jpg",
                  "hash": "large_sip_1_eb35b28131",
                  "mime": "image/jpeg",
                  "name": "large_sip 1.jpg",
                  "path": null,
                  "size": 133.31,
                  "width": 1000,
                  "height": 1000,
                  "sizeInBytes": 133313,
                  "provider_metadata": {
                    "public_id": "large_sip_1_eb35b28131",
                    "resource_type": "image"
                  }
                },
                "small": {
                  "ext": ".jpg",
                  "url": "https://res.cloudinary.com/ddn6ef2kw/image/upload/v1716313856/small_sip_1_eb35b28131.jpg",
                  "hash": "small_sip_1_eb35b28131",
                  "mime": "image/jpeg",
                  "name": "small_sip 1.jpg",
                  "path": null,
                  "size": 48.46,
                  "width": 500,
                  "height": 500,
                  "sizeInBytes": 48459,
                  "provider_metadata": {
                    "public_id": "small_sip_1_eb35b28131",
                    "resource_type": "image"
                  }
                },
                "medium": {
                  "ext": ".jpg",
                  "url": "https://res.cloudinary.com/ddn6ef2kw/image/upload/v1716313856/medium_sip_1_eb35b28131.jpg",
                  "hash": "medium_sip_1_eb35b28131",
                  "mime": "image/jpeg",
                  "name": "medium_sip 1.jpg",
                  "path": null,
                  "size": 87.88,
                  "width": 750,
                  "height": 750,
                  "sizeInBytes": 87877,
                  "provider_metadata": {
                    "public_id": "medium_sip_1_eb35b28131",
                    "resource_type": "image"
                  }
                },
                "thumbnail": {
                  "ext": ".jpg",
                  "url": "https://res.cloudinary.com/ddn6ef2kw/image/upload/v1716313856/thumbnail_sip_1_eb35b28131.jpg",
                  "hash": "thumbnail_sip_1_eb35b28131",
                  "mime": "image/jpeg",
                  "name": "thumbnail_sip 1.jpg",
                  "path": null,
                  "size": 8.17,
                  "width": 156,
                  "height": 156,
                  "sizeInBytes": 8167,
                  "provider_metadata": {
                    "public_id": "thumbnail_sip_1_eb35b28131",
                    "resource_type": "image"
                  }
                }
              },
              "hash": "sip_1_eb35b28131",
              "ext": ".jpg",
              "mime": "image/jpeg",
              "size": 1851.53,
              "url": "https://res.cloudinary.com/ddn6ef2kw/image/upload/v1716313856/sip_1_eb35b28131.jpg",
              "previewUrl": null,
              "provider": "cloudinary",
              "provider_metadata": {
                "public_id": "sip_1_eb35b28131",
                "resource_type": "image"
              },
              "createdAt": "2024-05-21T17:50:57.098Z",
              "updatedAt": "2024-05-21T17:50:57.098Z"
            }
          }
        }
      }
    },
    {
      "id": '2',
      "attributes": {
        "Title": "A Girl Can 1.0",
        "Description": 'Empowering the digital age',
        "Date": "2024-11-26",
        "Time": "09:00:00",
        "Address": "Poly High School, Ibadan & United Secondary School, Ijokodo",
        "Content": "",
        "createdAt": "2024-11-21T09:54:19.569Z",
        "updatedAt": "2024-11-21T09:54:19.569Z",
        "publishedAt": "2024-11-21T09:54:19.569Z",
        "Image": {
          "data": {
            "id": 2,
            "attributes": {
              "name": "padagirl.jpg",
              "alternativeText": null,
              "caption": null,
              "width": 6583,
              "height": 6583,
              "formats": {
                "large": {
                  "ext": ".jpg",
                  "url": "https://res.cloudinary.com/ddn6ef2kw/image/upload/v1732189865/A_GIRL_CAN_-_DAY_26_c8z3vl.jpg",
                  "hash": "large_sip_1_eb35b28131",
                  "mime": "image/jpeg",
                  "name": "large_sip 1.jpg",
                  "path": null,
                  "size": 133.31,
                  "width": 1000,
                  "height": 1000,
                  "sizeInBytes": 133313,
                  "provider_metadata": {
                    "public_id": "large_sip_1_eb35b28131",
                    "resource_type": "image"
                  }
                },
                "small": {
                  "ext": ".jpg",
                  "url": "https://res.cloudinary.com/ddn6ef2kw/image/upload/w_1000,ar_1:1,c_fill,g_auto,e_art:hokusai/v1732189865/A_GIRL_CAN_-_DAY_26_c8z3vl.jpg",
                  "hash": "small_sip_1_eb35b28131",
                  "mime": "image/jpeg",
                  "name": "small_sip 1.jpg",
                  "path": null,
                  "size": 48.46,
                  "width": 500,
                  "height": 500,
                  "sizeInBytes": 48459,
                  "provider_metadata": {
                    "public_id": "small_sip_1_eb35b28131",
                    "resource_type": "image"
                  }
                },
                "thumbnail": {
                  "ext": ".jpg",
                  "url": "https://res.cloudinary.com/ddn6ef2kw/image/upload/c_thumb,w_200,g_face/v1732189865/A_GIRL_CAN_-_DAY_26_c8z3vl.jpg",
                  "hash": "thumbnail_sip_1_eb35b28131",
                  "mime": "image/jpeg",
                  "name": "thumbnail_sip 1.jpg",
                  "path": null,
                  "size": 8.17,
                  "width": 156,
                  "height": 156,
                  "sizeInBytes": 8167,
                  "provider_metadata": {
                    "public_id": "thumbnail_sip_1_eb35b28131",
                    "resource_type": "image"
                  }
                }
              },
              "hash": "sip_1_eb35b28131",
              "ext": ".jpg",
              "mime": "image/jpeg",
              "size": 1851.53,
              "url": "https://res.cloudinary.com/ddn6ef2kw/image/upload/v1732189865/A_GIRL_CAN_-_DAY_26_c8z3vl.jpg",
              "previewUrl": null,
              "provider": "cloudinary",
              "provider_metadata": {
                "public_id": "sip_1_eb35b28131",
                "resource_type": "image"
              },
              "createdAt": "2024-05-21T17:50:57.098Z",
              "updatedAt": "2024-05-21T17:50:57.098Z"
            }
          }
        }
      }
    },
  ],
  "meta": {
    "pagination": {
      "page": 1,
      "pageSize": 25,
      "pageCount": 1,
      "total": 1
    }
  }
}
